export default "__VITE_PUBLIC_ASSET__9ccf375e__"